import Vue from 'vue'
// import Vue from 'vue/dist/vue.js';
import VueRouter from 'vue-router'
import App from './App.vue'
import MainLayout from './layout/Main.vue'
import Contact from './Contact.vue'
import Events from './Events.vue'
import NotFound from './NotFound.vue'

Vue.use(VueRouter);
const router = new VueRouter({
    mode: 'history',
    routes: [
        {path: '/', component: App, alias: ""},
        // {path: '/about', component: About},
        {path: '/kontakt', component: Contact, alias:"/contact"},
        // {path: '/menu', component: Menu},
        {path: '/akce',name:"Akce", component: Events, alias:"/events"},
        {path: '/kalendar',name:"Akce", component: Events, alias:"/calendar"},
        {path: '/404', component: NotFound},
    ] // short for `routes: routes`
});

new Vue({
    router,
    // eslint-disable-next-line no-unused-vars
    components: {MainLayout},
    template: '<main-layout><router-view></router-view></main-layout>'
}).$mount('#app');
